<p-dialog
  header="Select CAD for Node"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '80rem', maxWidth: '96vw', height: '82vh' }"
  [contentStyle]="{
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '0',
    overflow: 'hidden',
  }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
>
  @if (selection(); as selection) {
    <p class="mb-4 text-sm text-muted-color">
      Select the primary CAD object to use for this node.
    </p>
    <div
      class="max-h-[300px] overflow-y-auto rounded-lg border border-surface-switch-200"
    >
      @for (cadObject of selection.objects; track cadObject.id) {
        <label
          [class]="
            'flex cursor-pointer items-center gap-3 border-b border-surface-switch-100 px-4 py-3 transition-colors last:border-b-0 hover:bg-surface-switch-50 ' +
            (selection.selectedObjectId === cadObject.id ? 'bg-primary/5' : '')
          "
        >
          <p-radioButton
            name="primaryCadObject"
            [value]="cadObject.id"
            [ngModel]="selection.selectedObjectId"
            (ngModelChange)="selectCadObject($event)"
          />
          <span class="text-sm font-medium text-surface-switch-900">
            {{
              cadObject.name ||
                cadObject.step_ident ||
                "Object " + cadObject.index
            }}
          </span>
        </label>
      }
    </div>
    @if (selection.error) {
      <p-message severity="error" class="mt-3 block">
        {{ selection.error }}
      </p-message>
    }
  } @else {
    @if (activity().kind === "idle" || activity().kind === "error") {
      <p-tabs
        class="flex h-full min-h-0 flex-1 flex-col"
        [value]="uploadTab()"
        (valueChange)="setUploadTab($any($event))"
      >
        <p-tablist>
          <p-tab value="upload">Upload New CAD</p-tab>
          <p-tab value="existing">Use Existing CAD</p-tab>
        </p-tablist>
        <p-tabpanels class="flex min-h-0 flex-1 flex-col">
          <p-tabpanel value="upload" class="min-h-0 flex-1">
            <div class="mt-3 h-[calc(100%-0.75rem)]">
              <app-upload-cad
                class="block h-full"
                [multiple]="false"
                (filesSelected)="onUploadCadFilesSelected($event)"
              />
            </div>
          </p-tabpanel>
          <p-tabpanel value="existing" class="min-h-0 flex-1">
            <div class="mt-3 h-[calc(100%-0.75rem)]">
              <app-use-existing-cad
                class="block h-full"
                [multiple]="false"
                [forMoulding]="true"
                (filesSelected)="onExistingCadFilesSelected($event)"
              />
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    }
    @if (activity().kind === "uploading") {
      <div class="flex items-center justify-center gap-2 py-8">
        <i class="pi pi-spin pi-spinner text-primary"></i>
        <span class="text-sm text-muted-color">Uploading file...</span>
      </div>
    }
    @if (processingStatusText; as statusText) {
      <div class="flex items-center justify-center gap-2 py-8">
        <i class="pi pi-spin pi-spinner text-primary"></i>
        <span class="text-sm text-muted-color">
          {{ statusText }}
        </span>
      </div>
    }
    @if (activityError; as error) {
      <p-message severity="error" class="mt-3 block">
        {{ error }}
      </p-message>
    }
  }

  <ng-template pTemplate="footer">
    @if (selection(); as selection) {
      <div class="flex justify-end gap-2">
        <p-button
          label="Back"
          severity="secondary"
          [outlined]="true"
          (onClick)="showSources()"
        />
        <span
          [pTooltip]="
            processing.downstreamExecutionActive()
              ? 'Downstream steps are running. Wait for the sequence to finish.'
              : undefined
          "
          tooltipPosition="top"
        >
          <p-button
            label="Confirm"
            [loading]="selection.saving"
            [disabled]="
              selection.selectedObjectId === null ||
              selection.saving ||
              processing.downstreamExecutionActive()
            "
            (onClick)="confirmCadSelection()"
          />
        </span>
      </div>
    }
  </ng-template>
</p-dialog>
